import React from 'react';
import { Link } from 'react-router-dom';

import { AuthenticationWrapper } from '../AuthenticationWrapper';
import { FormContainer, ResetPasswordHeading, ResetPasswordSubheading, FormButtonContainer } from '../style';
import { paths } from '../../../../Constants/paths';
import { SemiTransparentButton } from '../../../Layouts';

export const PasswordUpdated = () => (
    <AuthenticationWrapper>
        <FormContainer>
            <ResetPasswordHeading>Password updated!</ResetPasswordHeading>
            <ResetPasswordSubheading>
                You can now log in on the website and app with your new password
            </ResetPasswordSubheading>
            <FormButtonContainer>
                <Link to={paths.SIGN_IN}>
                    <SemiTransparentButton>Log In</SemiTransparentButton>
                </Link>
            </FormButtonContainer>
        </FormContainer>
    </AuthenticationWrapper>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/ResetPassword/PasswordUpdated.js